import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
const UPSELL_NAME_AND_LOCATION_TO_MODAL_ORIGIN = {
    computer_vip_advisor: {
        HOMEPAGE_BOTTOM_CARD: ModalOrigin.HOMEPAGE_BOTTOM_CARD_COMPUTER_VIP_ADVISOR,
        BANNER: ModalOrigin.SETTINGS_BANNER_COMPUTER_VIP_ADVISOR,
    },
};
const UPSELL_NAME_TO_MODAL_ORIGIN = {
    logged_out_image_generation: ModalOrigin.IMAGE_GENERATION_IN_THREAD,
    logged_out_video_generation: ModalOrigin.VIDEO_GENERATION_IN_THREAD,
    subscription_upgrade_video_generation: ModalOrigin.VIDEO_GENERATION_IN_THREAD,
    pro_feature_limit_files: ModalOrigin.PRO_FEATURE_LIMIT_BANNER,
    login_for_comet_agent_queries: ModalOrigin.LOGIN_FOR_COMET_AGENT_QUERIES_IN_THREAD,
    comet_agent_queries_rate_limited: ModalOrigin.COMET_AGENT_QUERIES_RATE_LIMITED_IN_THREAD,
    logged_out_canvas_generation: ModalOrigin.CANVAS_GENERATION_IN_THREAD,
    free_user_canvas_generation: ModalOrigin.CANVAS_GENERATION_IN_THREAD,
    pro_user_canvas_generation: ModalOrigin.CANVAS_GENERATION_IN_THREAD,
    wait_for_browser_agent_confirmation: ModalOrigin.BROWSER_AGENT_CONFIRMATION_IN_THREAD,
    advanced_models_quota_low: ModalOrigin.ADVANCED_MODELS_QUOTA_LOW,
    gmail_gcal_connector: ModalOrigin.CONNECTORS_UPSELL,
    health_dashboard_upsell: ModalOrigin.HEALTH_DASHBOARD_UPSELL_IN_THREAD,
    pro_feature_limit_queries: ModalOrigin.PRO_FEATURE_LIMIT_BANNER,
    auto_upgrade_to_pro: ModalOrigin.PRO_FEATURE_LIMIT_BANNER,
    fraud_blocking_upsell: ModalOrigin.FRAUD_BLOCKING_GATE,
    fraud_authwall_upsell: ModalOrigin.FRAUD_AUTHWALL_GATE,
    taste_of_pro: ModalOrigin.TASTE_OF_PRO,
    comet_set_default_browser: ModalOrigin.COMET_SET_DEFAULT_BROWSER_IN_THREAD,
    create_shortcut: ModalOrigin.CREATE_SHORTCUT_IN_THREAD,
    wait_for_canvas_generation_confirmation: ModalOrigin.WAIT_FOR_CANVAS_GENERATION_IN_THREAD,
    virtual_try_on: ModalOrigin.VIRTUAL_TRY_ON_IN_THREAD,
    context_length_limit: ModalOrigin.CONTEXT_LENGTH_LIMIT_IN_THREAD,
    connector_auth_confirmation: ModalOrigin.CONNECTOR_AUTH_IN_THREAD,
    share_location: ModalOrigin.SHARE_LOCATION_IN_THREAD,
    difficult_query_computer: ModalOrigin.DIFFICULT_QUERY_COMPUTER_IN_THREAD,
    difficult_query_computer_free_user: ModalOrigin.DIFFICULT_QUERY_COMPUTER_FREE_USER_IN_THREAD,
    difficult_query_pro_upgrade: ModalOrigin.DIFFICULT_QUERY_PRO_UPGRADE_IN_THREAD,
    complex_query_computer_rewrite: ModalOrigin.COMPLEX_QUERY_COMPUTER_REWRITE_IN_THREAD,
    complex_query_computer_rewrite_follow_up: ModalOrigin.COMPLEX_QUERY_COMPUTER_REWRITE_IN_THREAD,
    computer_code_contextual_max_activation: ModalOrigin.COMPUTER_CODE_CONTEXTUAL_MAX_ACTIVATION,
    canvas_contextual_activation: ModalOrigin.CANVAS_CONTEXTUAL_ACTIVATION,
    canvas_contextual_activation_slides: ModalOrigin.CANVAS_CONTEXTUAL_ACTIVATION_SLIDES,
    canvas_contextual_activation_document: ModalOrigin.CANVAS_CONTEXTUAL_ACTIVATION_DOCUMENT,
    canvas_contextual_activation_generic: ModalOrigin.CANVAS_CONTEXTUAL_ACTIVATION_GENERIC,
    canvas_model_degradation: ModalOrigin.CANVAS_MODEL_DEGRADATION,
    premium_sources_computer_cb_insights: ModalOrigin.PREMIUM_SOURCES_COMPUTER,
    premium_sources_computer_pitchbook: ModalOrigin.PREMIUM_SOURCES_COMPUTER,
    premium_sources_computer_statista: ModalOrigin.PREMIUM_SOURCES_COMPUTER,
    deep_research_computer: ModalOrigin.DEEP_RESEARCH_COMPUTER,
    agentic_intent_computer: ModalOrigin.AGENTIC_INTENT_COMPUTER,
    finance_computer: ModalOrigin.FINANCE_COMPUTER,
    personal_finance_computer: ModalOrigin.PERSONAL_FINANCE_COMPUTER,
    productivity_connectors_computer: ModalOrigin.PRODUCTIVITY_CONNECTORS_COMPUTER,
    shopping_intent_download_comet: ModalOrigin.SHOPPING_INTENT_DOWNLOAD_COMET,
    restaurant_or_attractions_intent_download_comet: ModalOrigin.RESTAURANT_ATTRACTIONS_INTENT_DOWNLOAD_COMET,
    input_banner_pro_feature_limit: ModalOrigin.PRO_FEATURE_LIMIT_BANNER,
    input_banner_advanced_preview: ModalOrigin.INPUT_BANNER_ADVANCED_PREVIEW,
    input_banner_free_tier_rate_limited: ModalOrigin.LIMITED_FREE_TIER_RATE_LIMITED_INPUT_BANNER,
    pro_user_pro_search_limit: ModalOrigin.PRO_USER_PRO_SEARCH_LIMIT,
    pro_user_file_upload_limit: ModalOrigin.PRO_USER_FILE_UPLOAD_LIMIT,
    pro_user_research_limit: ModalOrigin.PRO_USER_RESEARCH_LIMIT,
    pro_upgrade: ModalOrigin.PRO_UPGRADE_IN_SIDE_HOMEPAGE,
    enterprise: ModalOrigin.ENTERPRISE_MAX_UPSELL,
    enterprise_max_side: ModalOrigin.ENTERPRISE_MAX_UPSELL,
    homepage_computer_badge: ModalOrigin.HOME_COMPUTER_BADGE,
    homepage_computer_badge_free_user: ModalOrigin.HOME_COMPUTER_BADGE,
    subscription_promotion_pro_upgrade_badge: ModalOrigin.SUBSCRIPTION_PROMO_DESCRIPTION,
    subscription_promotion_homepage_modal: ModalOrigin.SUBSCRIPTION_PROMO_DESCRIPTION,
    pro_trial_end_homepage_upsell: ModalOrigin.PRO_TRIAL_END_HOMEPAGE_UPSELL,
    homepage_microsoft_products_card: ModalOrigin.HOME_MICROSOFT_PRODUCTS_CARD,
    homepage_personal_cfo_card: ModalOrigin.HOME_PERSONAL_CFO_CARD,
    computer_max_side_card: ModalOrigin.COMPUTER_MAX_SIDE_CARD,
    computer_pro_side_card: ModalOrigin.COMPUTER_PRO_SIDE_CARD,
    create_team_sidebar: ModalOrigin.SIDEBAR_TEAM_INVITE,
    pro_annual_switch_sidebar: ModalOrigin.PRO_ANNUAL_SWITCH_SIDEBAR,
    computer_max_side_card_enterprise_admin: ModalOrigin.COMPUTER_MAX_SIDE_CARD_ENTERPRISE_ADMIN,
    computer_max_side_card_enterprise_member: ModalOrigin.COMPUTER_MAX_SIDE_CARD_ENTERPRISE_MEMBER,
    comet_download_banner: ModalOrigin.COMET_DOWNLOAD_BANNER,
    comet_android_banner: ModalOrigin.COMET_ANDROID_BANNER,
    comet_ios_download: ModalOrigin.COMET_IOS_DOWNLOAD,
    pro_referral: ModalOrigin.PRO_REFERRAL_SIDE_CARD,
    student_verification: ModalOrigin.STUDENT_VERIFICATION_SIDE_CARD,
    student_reverification: ModalOrigin.STUDENT_VERIFICATION_SIDE_CARD,
    winback_churned_pro: ModalOrigin.WINBACK_CHURNED_PRO,
    slack_mcp_connectors: ModalOrigin.SLACK_MCP_CONNECTORS,
    enterprise_consulting_side: ModalOrigin.ENTERPRISE_CONSULTING_SIDE,
    enterprise_pql_compliance: ModalOrigin.ENTERPRISE_PQL_COMPLIANCE,
    talk_to_sales_homepage_expansion: ModalOrigin.TALK_TO_SALES_HOMEPAGE_EXPANSION,
    talk_to_sales_homepage_net_new: ModalOrigin.TALK_TO_SALES_HOMEPAGE_NET_NEW,
    enterprise_comet_admin: ModalOrigin.ENTERPRISE_COMET_ADMIN,
    enterprise_connector_controls_admin: ModalOrigin.ENTERPRISE_CONNECTOR_CONTROLS_ADMIN,
    enterprise_comet_download: ModalOrigin.ENTERPRISE_COMET_DOWNLOAD,
    premium_data_for_max: ModalOrigin.PREMIUM_DATA_FOR_MAX,
    tasks_in_spaces: ModalOrigin.TASKS_IN_SPACES,
    enterprise_pro_computer_side: ModalOrigin.ENTERPRISE_PRO_COMPUTER_SIDE,
    gdrive_direct_api: ModalOrigin.GDRIVE_DIRECT_API,
    usc_study_hub: ModalOrigin.USC_STUDY_HUB,
    enterprise_memory_admin: ModalOrigin.ENTERPRISE_MEMORY_ADMIN,
    enterprise_memory_enable: ModalOrigin.ENTERPRISE_MEMORY_ENABLE,
    enterprise_memory_try: ModalOrigin.ENTERPRISE_MEMORY_TRY,
    enterprise_onboarding_connectors: ModalOrigin.ENTERPRISE_ONBOARDING_CONNECTORS,
    snowflake_service_account_connector: ModalOrigin.SNOWFLAKE_SERVICE_ACCOUNT_CONNECTOR,
    homepage_bottom_card_personalized: ModalOrigin.HOMEPAGE_BOTTOM_CARD_PERSONALIZED,
    homepage_bottom_card_computer_onboarding: ModalOrigin.HOMEPAGE_BOTTOM_CARD_COMPUTER_ONBOARDING,
    computer_thread_unsupported_app_version: ModalOrigin.COMPUTER_THREAD_UNSUPPORTED_APP_VERSION,
    comet_ntp_student_verification: ModalOrigin.COMET_NTP_STUDENT_VERIFICATION,
    comet_ntp_mobile_download: ModalOrigin.COMET_NTP_MOBILE_DOWNLOAD,
    deep_research_related_query: ModalOrigin.DEEP_RESEARCH_RELATED_QUERY_UPSELL,
    agentic_research_related_query: ModalOrigin.AGENTIC_RESEARCH_RELATED_QUERY,
    computer_related_query: ModalOrigin.COMPUTER_RELATED_QUERY,
    persona_computer_healthcare: ModalOrigin.PERSONA_COMPUTER_IN_THREAD,
    persona_computer_data_analyst: ModalOrigin.PERSONA_COMPUTER_IN_THREAD,
};
export const getUpsellModalOrigin = (upsellInformation) => {
    if (!upsellInformation?.name) {
        return ModalOrigin.UNSPECIFIED_GENERALIZED_UPSELL;
    }
    const locationSpecificOrigin = upsellInformation.app_location
        ? UPSELL_NAME_AND_LOCATION_TO_MODAL_ORIGIN[upsellInformation.name]?.[upsellInformation.app_location]
        : undefined;
    return (locationSpecificOrigin ??
        UPSELL_NAME_TO_MODAL_ORIGIN[upsellInformation.name] ??
        ModalOrigin.UNSPECIFIED_GENERALIZED_UPSELL);
};
//# sourceMappingURL=getUpsellModalOrigin.js.map